module.exports = __webpack_public_path__ + "static/media/laika-cms.2a6708d2.png";